// VerificationStatus.jsx
// Component for displaying verification status content

import React from 'react';
import { styles } from './styles';
import { COLORS } from '../../constants';

const VerificationStatus = ({ status, errorMsg, onRetry, onResend, onGoToLogin }) => {
  const renderContent = () => {
    switch (status) {
      case 'init':
        return (
          <p style={styles.statusText}>Validating link...</p>
        );

      case 'ready':
      case 'applying':
        return (
          <p style={styles.statusText}>Verifying your email...</p>
        );

      case 'success':
        return (
          <p style={styles.successText}>
            Email verified! Redirecting to marketplace...
          </p>
        );

      case 'alreadyVerified':
        return (
          <>
            <p style={styles.successText}>
              Your email has been verified!
            </p>
            <p style={styles.statusText}>
              Your email was already verified (likely by an email security scanner). 
              Redirecting you to the marketplace...
            </p>
          </>
        );

      case 'resent':
        return (
          <p style={styles.successText}>
            A new verification email was sent. Check your inbox.
          </p>
        );

      case 'invalid':
        return (
          <>
            <p style={styles.errorText}>Invalid verification link.</p>
            <button onClick={onGoToLogin} style={styles.primaryButton}>
              Go to Login
            </button>
          </>
        );

      case 'error':
        // Treat "already used" as success since email scanners click links first
        const isLinkExpired = errorMsg.includes('expired') || errorMsg.includes('already used') || errorMsg.includes('invalid-action-code');
        
        if (isLinkExpired) {
          // Show success message for expired/already-used links
          return (
            <>
              <p style={styles.successText}>
                Email Verification Complete!
              </p>
              <div style={{
                padding: '20px',
                backgroundColor: 'rgba(34, 197, 94, 0.08)',
                border: '2px solid rgba(34, 197, 94, 0.2)',
                borderRadius: '12px',
                marginTop: '20px',
                marginBottom: '24px'
              }}>
                <p style={{...styles.statusText, color: COLORS.text.primary, margin: 0}}>
                  Your email has been verified. This link was already used 
                  (likely by an email security scanner checking for malicious content).
                </p>
              </div>
              <div style={styles.actionsContainer}>
                <button 
                  onClick={onGoToLogin} 
                  style={styles.primaryButton}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 24px rgba(206, 17, 38, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 16px rgba(206, 17, 38, 0.3)';
                  }}
                >
                  Continue to Login
                </button>
              </div>
            </>
          );
        }
        
        // Only show actual errors for other issues
        return (
          <>
            <p style={styles.errorText}>Problem verifying email</p>
            <p style={styles.errorDetail}>{errorMsg}</p>
            <div style={styles.actionsContainer}>
              <button onClick={onGoToLogin} style={styles.primaryButton}>
                Try Logging In
              </button>
              <button onClick={onResend} style={styles.secondaryButton}>
                Request New Link
              </button>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return <>{renderContent()}</>;
};

export default VerificationStatus;